
import { CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

interface UsersStatsProps {
  totalUsers: number;
  onManualRefresh: () => void;
  refreshing: boolean;
}

export function UsersStats({ 
  totalUsers, 
  onManualRefresh, 
  refreshing 
}: UsersStatsProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <CardTitle className="flex items-center gap-2">
          All Users
          <Button
            variant="ghost"
            size="sm"
            onClick={onManualRefresh}
            disabled={refreshing}
            className="h-8 w-8 p-0"
          >
            <RefreshCw className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
          </Button>
        </CardTitle>
        <CardDescription>
          Manage admin user accounts, permissions, and invitations ({totalUsers} total users)
        </CardDescription>
      </div>
    </div>
  );
}
